import { render, staticRenderFns } from "./AddUpdateFoodMenu.vue?vue&type=template&id=97e40392"
import script from "./AddUpdateFoodMenu.vue?vue&type=script&lang=js"
export * from "./AddUpdateFoodMenu.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateFoodMenu.vue?vue&type=style&index=0&id=97e40392&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports